var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41709 12.6104C9.71298 12.6104 12.4199 9.90908 12.4199 6.61318C12.4199 3.31729 9.71298 0.610352 6.41709 0.610352C3.1212 0.610352 0.419922 3.31729 0.419922 6.61318C0.419922 9.90908 3.12686 12.6104 6.41709 12.6104ZM6.41709 8.62357C4.99567 8.62357 3.89137 9.11625 3.24578 9.75051C2.45296 8.94636 1.96027 7.8364 1.96027 6.61318C1.96027 4.14409 3.948 2.1507 6.41709 2.1507C8.88618 2.1507 10.8739 4.14409 10.8796 6.61318C10.8796 7.8364 10.3926 8.94636 9.59406 9.75051C8.94847 9.11625 7.84418 8.62357 6.41709 8.62357ZM6.41709 7.75148C5.30713 7.74579 4.45768 6.80573 4.45199 5.5995C4.44635 4.46122 5.31846 3.49284 6.41709 3.49284C7.51572 3.49284 8.38217 4.46122 8.38217 5.5995C8.38217 6.80573 7.52705 7.75712 6.41709 7.75148Z",
    fill: "#E0E0E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.de73948512bde6c302c57a856910b35b.svg";
export { ForwardRef as ReactComponent };